/* ============================================
   VELORNE — Product FX
   Particules + effet souris stylo
   ============================================ */
 
(function() {
 
  const pathParts = window.location.pathname.split('/');
  const handle = pathParts[pathParts.length - 1];
 
  const FX = {
    'velorne-erable': {
      type: 'fireflies',
      colors: ['#D4A855', '#F0C070', '#E8B84B', '#FFF8E0'],
      count: 55,
      speed: 0.3,
    },
    'velorne-santal-rouge': {
      type: 'embers',
      colors: ['#FF4422', '#FF7744', '#FF2200', '#FFAA44'],
      count: 60,
      speed: 0.8,
    },
    'velorne-santal-violet': {
      type: 'stars',
      colors: ['#C080FF', '#9040DD', '#E0B0FF', '#ffffff'],
      count: 70,
      speed: 0.2,
    },
    'velorne-palissandre': {
      type: 'leaves',
      colors: ['#E8B060', '#C8882A', '#F0C878', '#A86820'],
      count: 60,
      speed: 0.4,
    },
    'velorne-ebene': {
      type: 'moonlight',
      colors: ['#ffffff', '#E0E8FF', '#C0D0FF', '#A0B8FF'],
      count: 50,
      speed: 0.15,
    },
  };
 
  const fx = FX[handle];
  if (!fx) return;
 
  // ── Canvas ──
  const hero = document.querySelector('.product-detail__hero');
  if (!hero) return;
 
  const canvas = document.createElement('canvas');
  canvas.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;pointer-events:none;z-index:5;';
  hero.style.position = 'relative';
  hero.style.overflow = 'hidden';
  hero.appendChild(canvas);
 
  const ctx = canvas.getContext('2d');
 
  function resize() {
    canvas.width = hero.offsetWidth;
    canvas.height = hero.offsetHeight;
  }
  resize();
  window.addEventListener('resize', resize);
 
  // ── Particles ──
  function rnd(a, b) { return a + Math.random() * (b - a); }
  function rndColor() { return fx.colors[Math.floor(Math.random() * fx.colors.length)]; }
 
  function createParticle() {
    const w = canvas.width, h = canvas.height;
    if (fx.type === 'fireflies') return {
      x: rnd(0, w), y: rnd(0, h),
      size: rnd(1.5, 4), color: rndColor(),
      alpha: rnd(0.2, 0.8),
      vx: rnd(-0.3, 0.3) * fx.speed,
      vy: rnd(-0.3, 0.3) * fx.speed,
      phase: Math.random() * Math.PI * 2,
      pulseSpeed: rnd(0.02, 0.05),
    };
    if (fx.type === 'embers') return {
      x: rnd(0, w), y: h + 10,
      size: rnd(1, 3.5), color: rndColor(),
      alpha: rnd(0.4, 0.9),
      vx: rnd(-0.5, 0.5),
      vy: -rnd(0.5, 1.5) * fx.speed,
      life: 1, decay: rnd(0.003, 0.008),
      wobble: rnd(-0.02, 0.02),
      phase: Math.random() * Math.PI * 2,
    };
    if (fx.type === 'stars') return {
      x: rnd(0, w), y: rnd(0, h),
      size: rnd(0.8, 3), color: rndColor(),
      alpha: 0, targetAlpha: rnd(0.3, 0.9),
      phase: Math.random() * Math.PI * 2,
      pulseSpeed: rnd(0.01, 0.03),
    };
    if (fx.type === 'leaves') return {
      x: rnd(-20, w + 20), y: -20,
      size: rnd(4, 10), color: rndColor(),
      alpha: rnd(0.4, 0.8),
      vx: rnd(-0.3, 0.5), vy: rnd(0.3, 0.8) * fx.speed,
      rotation: Math.random() * Math.PI * 2,
      rotSpeed: rnd(-0.02, 0.02),
      wobble: 0, wobbleSpeed: rnd(0.02, 0.05),
    };
    if (fx.type === 'moonlight') return {
      x: rnd(0, w), y: rnd(0, h),
      size: rnd(0.5, 2.5), color: rndColor(),
      alpha: 0, targetAlpha: rnd(0.1, 0.6),
      phase: Math.random() * Math.PI * 2,
      pulseSpeed: rnd(0.005, 0.02),
      drift: rnd(-0.05, 0.05),
    };
  }
 
  const particles = [];
  for (let i = 0; i < fx.count; i++) {
    const p = createParticle();
    if (fx.type === 'embers') p.y = rnd(0, canvas.height);
    if (fx.type === 'stars' || fx.type === 'moonlight') p.alpha = p.targetAlpha * Math.random();
    particles.push(p);
  }
 
  let t = 0;
 
  function animate() {
    requestAnimationFrame(animate);
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    t += 0.016;
    const w = canvas.width, h = canvas.height;
 
    particles.forEach((p, i) => {
      if (fx.type === 'fireflies') {
        p.x += p.vx + Math.sin(t * 0.5 + p.phase) * 0.3;
        p.y += p.vy + Math.cos(t * 0.4 + p.phase) * 0.2;
        p.alpha = 0.3 + Math.sin(t * p.pulseSpeed * 60 + p.phase) * 0.4;
        if (p.x < -10) p.x = w + 10;
        if (p.x > w + 10) p.x = -10;
        if (p.y < -10) p.y = h + 10;
        if (p.y > h + 10) p.y = -10;
        ctx.globalAlpha = Math.max(0, p.alpha);
        ctx.fillStyle = p.color;
        ctx.shadowBlur = 8; ctx.shadowColor = p.color;
        ctx.beginPath(); ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2); ctx.fill();
        ctx.shadowBlur = 0;
      }
 
      if (fx.type === 'embers') {
        p.x += p.vx + Math.sin(t * 2 + p.phase) * 0.3;
        p.y += p.vy;
        p.vx += p.wobble;
        p.life -= p.decay;
        if (p.life <= 0 || p.y < -10) { particles[i] = createParticle(); return; }
        ctx.globalAlpha = p.life * p.alpha;
        ctx.fillStyle = p.color;
        ctx.shadowBlur = 6; ctx.shadowColor = p.color;
        ctx.beginPath(); ctx.arc(p.x, p.y, p.size * p.life, 0, Math.PI * 2); ctx.fill();
        ctx.shadowBlur = 0;
      }
 
      if (fx.type === 'stars') {
        p.phase += p.pulseSpeed;
        p.alpha = p.targetAlpha * (0.5 + Math.sin(p.phase) * 0.5);
        ctx.globalAlpha = p.alpha;
        ctx.fillStyle = p.color;
        ctx.beginPath(); ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2); ctx.fill();
        if (p.alpha > 0.5) {
          ctx.globalAlpha = p.alpha * 0.4;
          ctx.fillRect(p.x - p.size*2, p.y - 0.5, p.size*4, 1);
          ctx.fillRect(p.x - 0.5, p.y - p.size*2, 1, p.size*4);
        }
      }
 
      if (fx.type === 'leaves') {
        p.x += p.vx + Math.sin(t * p.wobbleSpeed + p.wobble) * 0.4;
        p.y += p.vy;
        p.rotation += p.rotSpeed;
        p.wobble += 0.01;
        if (p.y > h + 20) { particles[i] = createParticle(); return; }
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rotation);
        ctx.globalAlpha = p.alpha;
        ctx.fillStyle = p.color;
        ctx.beginPath();
        ctx.ellipse(0, 0, p.size * 0.4, p.size, 0, 0, Math.PI * 2);
        ctx.fill();
        ctx.restore();
      }
 
      if (fx.type === 'moonlight') {
        p.phase += p.pulseSpeed;
        p.alpha = p.targetAlpha * (0.4 + Math.sin(p.phase) * 0.6);
        p.x += p.drift;
        if (p.x < -5) p.x = w + 5;
        if (p.x > w + 5) p.x = -5;
        ctx.globalAlpha = Math.max(0, p.alpha);
        ctx.fillStyle = p.color;
        ctx.shadowBlur = 10; ctx.shadowColor = p.color;
        ctx.beginPath(); ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2); ctx.fill();
        ctx.shadowBlur = 0;
      }
    });
 
    ctx.globalAlpha = 1;
  }
 
  animate();
 
  // ── Pen tilt on mouse move ──
  const penImg = document.querySelector('.product-detail__pen');
  if (!penImg) return;
 
  penImg.style.transition = 'transform 0.4s cubic-bezier(0.22, 1, 0.36, 1)';
  penImg.style.willChange = 'transform';
  penImg.style.transformStyle = 'preserve-3d';
 
  window.addEventListener('mousemove', function(e) {
    const rect = hero.getBoundingClientRect();
    if (e.clientY < rect.top || e.clientY > rect.bottom) {
      penImg.style.transform = 'rotate(-5deg)';
      return;
    }
    const cx = rect.left + rect.width / 2;
    const cy = rect.top + rect.height / 2;
    const dx = (e.clientX - cx) / (rect.width / 2);
    const dy = (e.clientY - cy) / (rect.height / 2);
   penImg.style.transform = 'rotate(' + (-5 + dx * 12) + 'deg) translateX(' + (dx * 30) + 'px) translateY(' + (dy * -20) + 'px)';
  });
 
  window.addEventListener('mouseleave', function() {
    penImg.style.transform = 'rotate(-5deg)';
  });
 
})();